import { ReactNode, useCallback, useMemo, useState } from 'react';

import { ReportIssueContext } from './report-issue.context';
import { ReportIssueHandler } from './report-issue-handler';

type ReportIssueProviderProps = {
  children: ReactNode;
};

export function ReportIssueProvider({ children }: ReportIssueProviderProps) {
  const [showReportIssue, setShowReportIssue] = useState(false);

  const handleToggleReportIssue = useCallback((value: boolean) => {
    setShowReportIssue(value);
  }, []);

  const value = useMemo(
    () => ({ onToggleReportIssue: handleToggleReportIssue, showReportIssue }),
    [showReportIssue, handleToggleReportIssue],
  );

  return (
    <ReportIssueContext value={value}>
      <ReportIssueHandler />
      {children}
    </ReportIssueContext>
  );
}
